import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'rms-root',
  template: '<router-outlet />',
  imports: [RouterOutlet],
})
export class AppComponent {}
